import React from "react";
import {Box} from '@material-ui/core';
import "./style.css";
// import getCRM from "../../obtencionDatos/getCRM";

function InfoProyecto(props){

    const formatterPeso = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
      })

    return(
        <Box  className="container" >
            <div className="tittle"><h2 style={{margin: 0}}>{props.proyecto.nombre}</h2></div>
            <div className={"dataProyecto"}>
                <div className={"caja1"}>
                    <ul>
                        <li><b>SBU: </b>{props.proyecto.SBU} </li>
                        <li><b>Cliente: </b>{props.proyecto.cliente} </li>
                        <li><b>Cliente de Facturación: </b>{props.proyecto.clienteFacturacion} </li>
                    </ul>
                </div>
                <div className={"caja2"}>
                    <ul>
                    <li><b>Fecha Inicio: </b>{props.proyecto.fechaInicio}</li>
                        <li><b>Fecha Cierre: </b>{props.proyecto.fechaFinPlanificada}</li>
                        <li><b>Duración: </b>{props.proyecto.mesesDuracion} meses</li>
                    </ul>
                </div>
                <div className={"caja3"}>
                    <ul>
                        <li><b>Servicio: </b>{props.proyecto.servicio} </li>
                        <li><b>Monto total: </b>{formatterPeso.format(props.proyecto.montoTotal)} </li>
                    </ul>
                    
                </div>
            </div>
        </Box>
    );
}

export default InfoProyecto;